import React from 'react'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { PGA_COM_HOST } from 'env'
import { useSupportContactActions } from 'lib/support'
import { useStyles } from './styles'

const PRIVACY_POLICY_URL = `${PGA_COM_HOST}/pga-of-america/privacy-policy`
const PLATFORM_POLICIES_URL = `${PGA_COM_HOST}/platform-user-policies`
const TERMS_OF_SERVICE_URL = `${PGA_COM_HOST}/pga-of-america/terms-of-service`

const WelcomeFooter = () => {
  const classes = useStyles()
  const { openSupport } = useSupportContactActions()
  const currentYear = new Date().getFullYear()

  return (
    <Box component="footer" className={classes.stickyFooter}>
      <Typography component="span" className={classes.footerCopyright}>
        &copy; {currentYear} PGA of America
      </Typography>
      <Box className={classes.footerLinks}>
        <Link
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.footerLink}
          underline="none"
        >
          Privacy Policy
        </Link>
        <Link
          href={PLATFORM_POLICIES_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.footerLink}
          underline="none"
        >
          Platform Policies
        </Link>
        <Link
          href={TERMS_OF_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.footerLink}
          underline="none"
        >
          Terms of Service
        </Link>
        <Link
          component="button"
          type="button"
          onClick={openSupport}
          className={classes.footerLinkAccent}
          underline="none"
        >
          Contact support
        </Link>
      </Box>
    </Box>
  )
}

export default WelcomeFooter
